/** @jsx jsx */
import { cssMap, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import type { ControlProps } from '@atlaskit/select';
import SearchIcon from '@atlaskit/icon/core/search';
import { Box } from '@atlaskit/primitives';
import { fg } from '@atlassian/jira-feature-gating';
import type { SelectOption } from '../../../../common/types.tsx';
import { StyledControl } from '../../../../common/ui/picker/styled.tsx';

const styles = cssMap({
	control: {
		display: 'flex',
		borderStyle: 'solid',
		borderWidth: token('border.width'),
		borderRadius: token('radius.small'),
		borderColor: token('color.border.input'),
		color: token('color.text.subtlest'),
		marginTop: token('space.0'),
		marginRight: token('space.150'),
		marginBottom: token('space.0'),
		marginLeft: token('space.150'),
		'&:focus-within': {
			boxShadow: `inset 0 0 0 ${token('border.width')} ${token('color.border.focused')}`,
			borderColor: `${token('color.border.focused')}`,
		},
	},
	wrapper: {
		display: 'flex',
		alignItems: 'center',
		paddingLeft: token('space.100'),
	},
});

export const Control = ({ children, innerProps, innerRef }: ControlProps<SelectOption, true>) => {
	if (fg('slv-117-nin-column-picker-style-updates')) {
		return (
			<div ref={innerRef ?? undefined} {...innerProps} css={styles.control}>
				<Box xcss={styles.wrapper}>
					<SearchIcon label="" />
				</Box>
				{children}
			</div>
		);
	}

	return (
		<StyledControl ref={innerRef ?? undefined} {...innerProps}>
			<Box xcss={styles.wrapper}>
				<SearchIcon label="" />
			</Box>
			{children}
		</StyledControl>
	);
};

export default Control;
